import { ContactPersonListItemDto } from '@api/contact-person/@shared/contact-person-list-item.dto';
import { Person } from '@common/entities';
import { PersonModel } from 'src/app/person/@shared/person.model';

export class ContactPersonModel extends PersonModel {
  public personId: string;
  public organizationId: string;
  public organizationName: string;
  public organizationType: string;
  public organizationSubType?: string;
  public personDisplayName: string;
  public email: string;
  public phoneNumber: string;

  constructor(source: ContactPersonListItemDto) {
    super({
      ...source,
      emails: source.email
        ? [source.email]
        : [],
      organizations: [],
      phoneNumbers: source.phoneNumber
        ? [source.phoneNumber]
        : [],
    } as unknown as Person);
    this.personDisplayName = this.displayName || source.name || '';
    this.personId = source.personId;
    this.organizationId = source.organizationId;
    this.organizationName = source.organizationName;
    this.organizationType = source.organizationType;
    this.organizationSubType = source.organizationSubType;
    this.email = source.email || '';
    this.phoneNumber = source.phoneNumber || '';
    this.displayName = [this.personDisplayName, source.organizationName].filter(Boolean).join(' · ');
  }
}
